<template>
    <div>
        <div v-if="gpsLocation && (gpsLocation.latitude && gpsLocation.longitude)">
            <span class="gps_location">GPS: {{ gpsLocation.latitude || '-' }}, {{ gpsLocation.longitude || '-' }}</span>
            <div :id="mapId" class="map" tabindex="0" :style="`height: ${mapHeight}px`" />
        </div>
        <div v-else class="empty-map">-</div>
    </div>
</template>

<script>
import "ol/ol.css";
import Map from "ol/Map";
import Feature from "ol/Feature";
import { Point } from "ol/geom";
import OSM from "ol/source/OSM";
import TileLayer from "ol/layer/Tile";
import View from "ol/View";
import { fromLonLat } from "ol/proj";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { Fill, Stroke, Circle, Style, Icon } from "ol/style";

export default {
    props: {
        mapId: {
            type: String,
            default: "my_map"
        },
        gpsLocation: {
            type: Object,
        },
        mapHeight: {
            type: String,
            default: "120"
        }
    },
    watch: {
        gpsLocation() {
            this.$nextTick(() => {
                if (this.gpsLocation && Object.keys(this.gpsLocation).length > 0) {
                    this.drawMap();
                }
            });
        }
    },
    methods: {
        drawMap() {
            if (document.getElementById(this.mapId)) {
                document.getElementById(this.mapId).innerHTML = "";
            }
                
            var lan = this.gpsLocation.latitude;
            var long = this.gpsLocation.longitude;

            const map = new Map({
                target: this.mapId,
                layers: [
                    new TileLayer({
                        source: new OSM()
                    })
                ],
                view: new View({
                    center: fromLonLat([long, lan]),
                    zoom: 17
                })
            });

            var marker = new Feature({
                geometry: new Point(
                    fromLonLat([long, lan])
                ),
            });

            marker.setStyle(new Style({
                image: new Icon(({
                    crossOrigin: "anonymous",
                    opacity: 1,
                    scale: 0.4,
                    anchor: [0.5, 1],
                    src: require("@/assets/images/map/marker_small.png")
                }))
            }));

            var vectorSource = new VectorSource({
                features: [marker]
            });

            var markerVectorLayer = new VectorLayer({
                source: vectorSource,
            });
                
            map.addLayer(markerVectorLayer);
        }
    }
};
</script>

<style lang="css" scoped>
.map {
    width: 100%;
    border-radius: 16px;
    margin: var(--space-8) 0;
} 
.empty-map {
    padding: 0 8px;
    height: 120px;
}
.gps_location {
    font-size: 13px;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/RecordingMap2.vue